

// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
 import {Deserializable} from "./deserializable.model";

export class JobSubject {

    subject_id?: number;
    job_id?: number;
    first_name?: string;
    middle_name?: string;
    surname?: string;
    title?: string;
    is_active?: string;
    next_date?: string;
    final_date?: string;
    job_status_id?: number;
    street_address?: string;
    suburb?: string;
    state?: string;
    postcode?: string;
    phone_h?: string;
    email?: string;
    dob?: string;
    phone_m?: string;
    subject_type_id?: number;
    file_number?: any;
    special_instructions?: string;
    job_status?: any;
    reference_number?: string;
    job_reference_number?: string;
    subject_number?: string;
    created_by?: number;
    created_date?: string;
    updated_date?: string;
    updated_by?: number;
    completed_date?: string;
    completed_by?: string;
    start_date?: string;
    started_by?: string;
    time_taken?: string;
    sex?: string;
    finalised?: string;
    subject_reference_created?: string;
    brand_report_user_id?: number;
    job_type_id?: any;
    job_type_location_id?: number;
    job_type_court_id?: number;
    job_type_document_type_id?: number;
    job_type_affidavit_type_id?: number;
    business_name?: string;
    prev_subject_id?: number;
    next_subject_id?: number;


    number_subjects?: number;
    existing_subjects_count?: number;

    job_subject_type_id?: number;
    subject_report_order_number?: number;

    job_service_rule_id?: number;
    job_service_timeframe_id?: number;
    subject_service_type_id: number;

    service_company_name?: string;
service_directors_name?: string;
service_prison_name?: string;
service_law_firm_name?: string;
 service_solicitor_name?: string;


brand_report_id?;
brand_invoice_id?;
// brand_report_user_id?;


brand_report_name?: string;
brand_invoice_name?: string;
client_reference?: string;

instructions_date?: string;
hearing_date?: string;
judgement_date?: string;
filing_date?: string;

  // ? what does this really do? (no encoding or deserialisation required...)
/*   deserialize(input: any): JobSubject {
    Object.assign(this, input);

    return this;
  } */


// search options / filters
created_date_from?: string;
created_date_to?: string;
next_date_from?: string;
next_date_to?: string;
final_date_from?: string;
final_date_to?: string;
hearing_date_from?: string;
hearing_date_to?: string;

special_instructions_HTML?: string;
job_status_code?;
limit?;
order_by?;
sort_by?;

timeframe_surcharge_id?: number;

}

  // Set the Stats




  /*



CREATE TABLE subjects (
  subject_id int(11) NOT NULL AUTO_INCREMENT,
  job_id int(11) DEFAULT NULL,
  first_name varchar(255) DEFAULT NULL,
  surname varchar(255) DEFAULT NULL,
  title varchar(255) DEFAULT NULL,
  is_active varchar(255) DEFAULT NULL,
  next_date varchar(255) DEFAULT NULL,
  final_date varchar(255) DEFAULT NULL,
  job_status_id int(11) DEFAULT NULL,
  street_address varchar(255) DEFAULT NULL,
  suburb varchar(255) DEFAULT NULL,
  state varchar(255) DEFAULT NULL,
  postcode int(11) DEFAULT NULL,
  phone_h varchar(255) DEFAULT NULL,
  email varchar(255) DEFAULT NULL,
  dob varchar(255) DEFAULT NULL,
  phone_m varchar(255) DEFAULT NULL,
  subject_type_id int(11) DEFAULT NULL,
  file_number varchar(255) DEFAULT '1',
  special_instructions text,
  job_status varchar(255) DEFAULT 'OPEN',
  reference_number int(11) DEFAULT NULL,
  job_reference_number int(11) DEFAULT NULL,
  subject_number varchar(255) DEFAULT NULL,
  created_by int(11) DEFAULT NULL,
  created_date int(11) DEFAULT NULL,
  updated_date varchar(255) DEFAULT NULL,
  updated_by int(11) DEFAULT NULL,
  completed_date varchar(255) DEFAULT NULL,
  completed_by int(11) DEFAULT NULL,
  start_date varchar(11) DEFAULT NULL,
  started_by int(11) DEFAULT NULL,
  time_taken int(11) DEFAULT NULL,
  sex varchar(11) DEFAULT NULL,
  finalised int(11) NOT NULL DEFAULT '0',
  subject_reference_created int(11) DEFAULT '0',
  brand_report_user_id int(11) DEFAULT NULL,
  job_type_id int(11) DEFAULT NULL,
  job_type_location_id int(11) DEFAULT NULL,
  job_type_court_id int(11) DEFAULT NULL,
  job_type_document_type_id int(11) DEFAULT NULL,
  job_type_affidavit_type_id int(11) DEFAULT NULL,
  business_name varchar(255) DEFAULT NULL,
  prev_subject_id int(11) DEFAULT '0',
  next_subject_id int(11) DEFAULT '0',
  PRIMARY KEY (subject_id),
  KEY FK_subjects (job_id),
  CONSTRAINT FK_subjects FOREIGN KEY (job_id) REFERENCES jobs (job_id)
) ENGINE=InnoDB AUTO_INCREMENT=303 DEFAULT CHARSET=utf8

  
*/